import { connect } from 'react-redux'
import HorizontalStepper from '../component/HorizontalStepper'
import { updateStep,
         resetStart, resetStep, resetPerson, resetAddress, resetThirdParty, resetMailShip, resetExportImport, 
         resetCurrencyItem, resetCoinItem, resetOtherItem, resetReviewSign, resetReceipt, } from '../actions'

const mapStateToProps = (state) => {
  return {
    activeStep: state.activeStep,
    start: state.start,
    exportImport: state.exportImport,
    currencies: state.currencies,
    coins: state.coins,
    others: state.others
  }
}

// const mapDispatchToProps = (dispatch, ownProps) => ({
//   updateStep: () => dispatch(updateStep(ownProps.activeStep)),
// })

const mapDispatchToProps = (dispatch) => {
  return {
    updateStep: (step) => dispatch(updateStep(step)),

    resetStart: () => dispatch(resetStart()),
    resetStep: () => dispatch(resetStep()),
    resetPerson: () => dispatch(resetPerson()),
    resetAddress: () => dispatch(resetAddress()),
    resetExportImport: () => dispatch(resetExportImport()),
    resetMailShip: () => dispatch(resetMailShip()),
    resetThirdParty: () => dispatch(resetThirdParty()),
    resetCurrencyItem: () => dispatch(resetCurrencyItem()),
    resetCoinItem: () => dispatch(resetCoinItem()),
    resetOtherItem: () => dispatch(resetOtherItem()),
    resetReviewSign: () => dispatch(resetReviewSign()),
    resetReceipt: () => dispatch(resetReceipt()),  
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (HorizontalStepper);